export default __webpack_public_path__ + "static/media/awaiting1F.cab70108.svg";